/* dl-search.js — one search takeover for header, homepage hero and "/"
   Backed by Shopify Predictive Search (/search/suggest.json). */
(function(){
const $=(s,e=document)=>e.querySelector(s), $$=(s,e=document)=>[...e.querySelectorAll(s)];
const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const cfg=window.DL_SEARCH||{};
/* 2026-08-03 fix: routes.predictive_search_url renders as /search/suggest (no .json) —
   fetching that returns HTTP 422 and the takeover silently never updated. */
let ROOT=(cfg.routes&&cfg.routes.predictive)||"/search/suggest";
if(!/\.json$/.test(ROOT)) ROOT+=".json";
const SEARCH_URL=(cfg.routes&&cfg.routes.search)||"/search";
const CATALOG=cfg.catalogCount||"";
/* store money format: 4.389,00 Kč (cs-CZ uses nbsp thousands — swap for dots) */
const fmtPrice=v=>{const n=parseFloat(v);if(!isFinite(n))return"";return n.toLocaleString("cs-CZ",{minimumFractionDigits:2,maximumFractionDigits:2}).replace(/[\u00A0\u202F ]/g,".")+" Kč";};

const css=document.createElement("style");
css.textContent=`
.dls-scrim{position:fixed;inset:0;background:rgba(20,18,12,.42);opacity:0;pointer-events:none;transition:opacity .2s ease;z-index:10001}
.dls-scrim.open{opacity:1;pointer-events:auto}
.dls{position:fixed;left:0;right:0;top:0;z-index:10002;background:#fff;transform:translateY(-101%);transition:transform .26s cubic-bezier(.4,0,.2,1);box-shadow:0 24px 48px rgba(20,18,12,.16)}
.dls.open{transform:none}
.dls .q{display:flex;align-items:center;gap:14px;padding:20px clamp(20px,3vw,46px) 16px;border-bottom:1px solid var(--line-2,#EEEDE9)}
.dls .q .ic{width:24px;height:24px;color:#98948C;flex:none}
.dls .q input{flex:1;min-width:0;border:none;outline:none;background:none;font:inherit;font-size:clamp(22px,2.6vw,30px);font-weight:700;letter-spacing:-.03em;color:#1A1916;caret-color:#D81E22}
.dls .q input::placeholder{color:#98948C;font-weight:600}
.dls .q .esc{font-family:var(--mono);font-size:11px;font-weight:700;color:#98948C;border:1px solid #E5E3DE;padding:5px 9px;text-transform:uppercase;letter-spacing:.08em}
.dls .q .esc:hover{border-color:#1A1916;color:#1A1916}
.dls .grid{display:grid;grid-template-columns:320px 1fr}
.dls h6{font-family:var(--mono);font-size:10.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#98948C;margin:0 0 10px}
.dls .col{padding:20px clamp(20px,3vw,46px) 24px}
.dls .col.l{border-right:1px solid #EEEDE9}
.dls .sug a{display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:8px 10px;margin:0 -10px;font-size:15.5px;font-weight:600;color:#1A1916}
.dls .sug a:hover,.dls .sug a.sel{background:#faf4f2;color:#C5161B}
.dls .sug a .k{font-family:var(--mono);font-size:10px;color:#98948C;font-weight:500;white-space:nowrap}
.dls .res{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:1px;background:#E5E3DE}
.dls .empty{font-size:15.5px;color:#57544E;padding:4px 0 10px}
.dls .foot{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px clamp(20px,3vw,46px);border-top:1px solid #EEEDE9;font-family:var(--mono);font-size:11px;color:#98948C;letter-spacing:.06em;text-transform:uppercase}
.dls .foot a.all{font-family:inherit;font-size:14.5px;font-weight:700;color:#1A1916;text-transform:none;letter-spacing:-.01em}
.dls .foot a.all span{color:#C5161B}
.dls mark{background:none;color:#C5161B}
@media (max-width:900px){.dls .grid{grid-template-columns:1fr}.dls .col.l{border-right:none;border-bottom:1px solid #EEEDE9}.dls .res{grid-template-columns:repeat(2,minmax(0,1fr))}}
`;
document.head.appendChild(css);

const scrim=document.createElement("div"); scrim.className="dls-scrim";
const box=document.createElement("div"); box.className="dls";
box.innerHTML='<div class="q"><svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg><input type="search" autocomplete="off" placeholder="Hledejte produkty, značky, kategorie nebo místnosti"><span class="esc">esc</span></div><div class="grid"><div class="col l"><h6 class="st">Nejhledanější</h6><nav class="sug"></nav></div><div class="col"><h6 class="rt">Oblíbené produkty</h6><div class="res"></div><div class="empty" hidden></div></div></div><div class="foot"><a class="all" href="'+SEARCH_URL+'">Kompletní katalog'+(CATALOG?" · "+CATALOG:"")+' <span>→</span></a><span>↑↓ procházet · enter otevřít · esc zavřít</span></div>';
document.body.append(scrim,box);

const input=$("input",box), sug=$(".sug",box), res=$(".res",box), empty=$(".empty",box);
const DEFAULTS=cfg.defaults||{queries:[],products:[]};
const pcard=p=>'<a class="pcard" href="'+p.url+'"><span class="th"><img src="'+p.image+'" alt="" loading="lazy"><span class="pr">'+p.price+'</span></span><span class="meta"><span class="nm">'+esc(p.title)+'</span><span class="br">'+esc(p.vendor)+'</span></span></a>';
let sel=0, timer=null, ctrl=null, usedArrows=false;

function renderDefault(){
  $(".st",box).textContent="Nejhledanější"; $(".rt",box).textContent="Oblíbené produkty";
  sug.innerHTML=DEFAULTS.queries.map((q,i)=>'<a href="'+q.url+'" class="'+(i?"":"sel")+'"><span>'+esc(q.label)+'</span><span class="k">'+esc(q.meta||"")+'</span></a>').join("");
  res.innerHTML=DEFAULTS.products.map(pcard).join(""); res.hidden=false; empty.hidden=true;
  $(".all",box).innerHTML='Kompletní katalog'+(CATALOG?" · "+CATALOG:"")+' <span>→</span>';
  $(".all",box).href=SEARCH_URL;
}
async function run(q){
  ctrl&&ctrl.abort(); ctrl=new AbortController();
  const url=ROOT+"?q="+encodeURIComponent(q)+"&resources[type]=query,collection,product&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last";
  let d; try{ d=await (await fetch(url,{signal:ctrl.signal})).json(); }catch(e){ return; }
  if(!d||!d.resources||!d.resources.results) return;
  const r=d.resources.results;
  $(".st",box).textContent="Návrhy"; $(".rt",box).textContent="Produkty";
  const items=[
    ...(r.collections||[]).map(c=>({label:c.title,url:c.url,meta:"kolekce"})),
    ...(r.queries||[]).map(x=>({label:x.text,url:SEARCH_URL+"?q="+encodeURIComponent(x.text)+"&type=product",meta:"dotaz"}))
  ].slice(0,7);
  sug.innerHTML=items.length
    ? items.map((s,i)=>'<a href="'+s.url+'" class="'+(i?"":"sel")+'"><span>'+esc(s.label)+'</span><span class="k">'+esc(s.meta)+'</span></a>').join("")
    : '<a><span style="color:#98948C;font-weight:500">Žádné návrhy</span></a>';
  const prods=(r.products||[]).slice(0,8).map(p=>({url:p.url,title:p.title,vendor:p.vendor,price:fmtPrice(p.price),image:p.featured_image&&p.featured_image.url}));
  if(prods.length){ res.hidden=false; empty.hidden=true; res.innerHTML=prods.map(pcard).join("");
    $(".all",box).innerHTML='Všechny výsledky pro „'+esc(q)+'" <span>→</span>';
    $(".all",box).href=SEARCH_URL+"?q="+encodeURIComponent(q)+"&type=product";
  } else { res.hidden=true; empty.hidden=false;
    empty.innerHTML='Pro <b>„'+esc(q)+'"</b> jsme nenašli žádné produkty. Zkuste „závěsná", „artemide" nebo „E27".'; }
  sel=0; usedArrows=false;
}
input.addEventListener("input",()=>{
  const q=input.value.trim(); clearTimeout(timer); usedArrows=false;
  if(!q){ renderDefault(); return; }
  timer=setTimeout(()=>run(q),180);
});
function open(seed){
  if(seed!==undefined&&seed!==null) input.value=seed;
  usedArrows=false;
  scrim.classList.add("open"); box.classList.add("open"); document.body.style.overflow="hidden";
  input.value.trim()?run(input.value.trim()):renderDefault();
  setTimeout(()=>input.focus(),40);
}
function close(){ scrim.classList.remove("open"); box.classList.remove("open"); document.body.style.overflow=""; input.blur(); }
scrim.addEventListener("click",close); $(".esc",box).addEventListener("click",close);
document.addEventListener("keydown",e=>{
  if(e.key==="/"&&!box.classList.contains("open")&&!/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)){e.preventDefault();open("");return;}
  if(!box.classList.contains("open")) return;
  if(e.key==="Escape"){ input.value?(input.value="",renderDefault()):close(); }
  if(e.key==="ArrowDown"||e.key==="ArrowUp"){
    e.preventDefault(); const it=$$("a",sug); if(!it.length) return;
    usedArrows=true;
    sel=(sel+(e.key==="ArrowDown"?1:-1)+it.length)%it.length;
    it.forEach((a,i)=>a.classList.toggle("sel",i===sel));
  }
  if(e.key==="Enter"){
    const q=input.value.trim(); const a=$("a.sel",sug);
    if(usedArrows&&a&&a.href){ location.href=a.href; }
    else if(q){ location.href=SEARCH_URL+"?q="+encodeURIComponent(q)+"&type=product"; }
    else if(a&&a.href){ location.href=a.href; }
  }
});
$$("[data-search-open]").forEach(el=>el.addEventListener("click",e=>{e.preventDefault();open("")}));
$$("[data-search-input]").forEach(i=>{
  i.addEventListener("focus",()=>open(i.value));
  i.closest("form")&&i.closest("form").addEventListener("submit",e=>{e.preventDefault();open(i.value)});
});
window.DLSearch={open,close};
})();
